import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ICrewMember } from '../models/crew-member.model';
import { HGGetEmployeesByPRCoPRGroup_Result } from '../../../type-definitions/crewtimecard/responses/crewtimecard';

@Injectable({
  providedIn: 'root',
})
export class CrewTimecardService {
  http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  getAllLayouts() {
    const url = '/CrewTimecard/GetAllLayouts';
    return this.http.get(url).toPromise();
  }

  getBulkEmployeeList(pRCo: number, pRGroup: number): Promise<HGGetEmployeesByPRCoPRGroup_Result[]> {
    const url = '/CrewTimecard/GetBulkEmployeeList';
    const params = new HttpParams().set('pRCo', pRCo).set('pRGroup', pRGroup);
    return this.http.get<HGGetEmployeesByPRCoPRGroup_Result[]>(url, { params: params }).toPromise();
  }

  getCellPossibleValues(rowData) {
    const url = '/Timecard/GetCellPossibleValues';
    return this.http.post(url, rowData).toPromise();
  }
  getCellPossibleValuesByEmployee(columnName: string, pRPCKeyID: number, employee: string = null, prehKeyID: number = null) {
    const url = '/Timecard/GetCellPossibleValues';
    const postData = {
      column: columnName,
      payPeriod: pRPCKeyID,
      employee: employee,
      prehKeyID: prehKeyID
    }
    return this.http.post(url, postData).toPromise();
  }

  getCrewClockInStatus(pRPCKeyID, crewTemplateID) {
    const url = '/CrewTimecard/GetCrewClockInStatus?pRPCKeyID=' + pRPCKeyID + '&crewTemplateID=' + crewTemplateID;
    return this.http.get(url).toPromise();
  }

  getEmplLockStatus(hQBCKeyID, crewTemplateID) {
    const url = '/CrewTimecard/GetEmplLockStatus?hQBCKeyID=' + hQBCKeyID + '&crewTemplateID=' + crewTemplateID;
    return this.http.get(url).toPromise();
  }

  getJobsByAuthToken(form, searchString) {
    const url = '/CrewTimecard/GetJobsByAuthToken?form=TC&searchString=' + searchString;
    return this.http.get(url).toPromise();
  }

  getLayout(crewLayoutID) {
    const url = '/Crew/Timecard/Layout?crewLayoutID=' + crewLayoutID;
    return this.http.get(url).toPromise();
  }

  getLookupValues(crewLayoutDetailID, crewTemplateID, pRPCKeyID) {
    const url =
      '/Crew/Timecard/GetLookupValues?crewLayoutDetailID=' +
      crewLayoutDetailID +
      '&crewTemplateID=' +
      crewTemplateID +
      '&pRPCKeyID=' +
      pRPCKeyID;
    return this.http.get(url).toPromise();
  }

  getPayPeriodDetails(pRPCKeyID, isCrewOrStandard: string) {
    const url = '/Timecard/GetPayPeriodDetails/?prpcKeyID=' + pRPCKeyID + '&isCrewOrStandard=' + isCrewOrStandard;
    return this.http.get(url).toPromise();
  }

  getPayPeriodsByTemplate(template) {
    const url = '/CrewTimecard/GetPayPeriodsByTemplate?crewTemplateID=' + template;
    return this.http.get(url).toPromise();
  }

  getCrews(pRCo, pRGRoup) {
    const url = '/CrewTimecard/GetCrews?PRCo=' + pRCo + '&PRGroup=' + pRGRoup;
    return this.http.get(url).toPromise();
  }

  getCrewMember(pRCRKeyID: number): Promise<ICrewMember[]> {
    return this.http.get<ICrewMember[]>(`/CrewTimecard/GetCrewMember?PRCRKeyID=${pRCRKeyID}`).toPromise();
  }

  getCrewTimecardColumns(crewTemplateID, timecardGroupID) {
    const url = '/CrewTimecard/GetColumns?templateID=' + crewTemplateID + '&timecardGroupId=' + timecardGroupID;
    return this.http.get(url).toPromise();
  }

  getLineTypesByTemplate(crewTemplateID, timecardGroupID) {
    const url = '/CrewTimecard/GetLineTypesByTemplate?templateID=' + crewTemplateID + '&timecardGroupId=' + timecardGroupID;
    return this.http.get(url).toPromise();
  }

  getPhasesByJCJMKeyID(jCJMKeyID, laborOnly) {
    const url = '/Crew/Timecard/GetPhasesByJCJMKeyID?jCJMKeyID=' + jCJMKeyID + '&laborOnly=' + laborOnly;
    return this.http.get(url).toPromise();
  }

  getPREHKeyIDByEmployee(pRCo, employee) {
    const url = '/Employee/GetPREHKeyIDByEmployee?pRCo=' + pRCo + '&employee=' + employee;
    return this.http.get(url).toPromise();
  }

  getQuestions(payPeriod) {
    const url = '/CrewTimecard/GetQuestions?timecardGroupID=' + payPeriod.TimecardGroupID;
    return this.http.get(url).toPromise();
  }

  getRequiredColumns(timecardGroupID) {
    const url = '/Timecard/GetRequiredColumns?timecardGroupID=' + timecardGroupID;
    return this.http.get(url).toPromise();
  }

  getTemplateDays(crewTemplateID) {
    const url = '/CrewTimecard/GetTemplateDays?crewTemplateID=' + crewTemplateID;
    return this.http.get(url).toPromise();
  }

  getTemplatesByPRPCKeyID(pRPCKeyID, crewTemplateID = null) {
    let url = '/CrewTimecard/GetTemplatesByPRPCKeyID?pRPCKeyID=' + pRPCKeyID;
    if (crewTemplateID != null) url += '&templateID=' + crewTemplateID;
    return this.http.get(url).toPromise();
  }

  getTimecardColumns(pRCo, pRGroup, isCrewOrStandard, filterType: string = null) {
    const url = '/Timecard/GetTimecardColumns?&pRCo=' + pRCo + '&pRGroup=' + pRGroup + '&isCrewOrStandard=' + isCrewOrStandard;
    return this.http.get(url).toPromise();
  }

  getPayPeriods(isJobApproval: boolean, payPdStatus: number = null) {
    let url = '/CrewTimecard/PayPeriods?isJobApproval=' + isJobApproval;
    if (payPdStatus != null) url += '&payPdStatus=' + payPdStatus;
    return this.http.get(url).toPromise();
  }

  cloneCrewTimecard(
    cloneFromTemplateID,
    cloneToTemplateID,
    cloneFromPRPCKeyID,
    cloneToPRPCKeyID,
    isCloneHours,
    cloneType,
    dateFromString = null,
    dateToString = null,
    employeeList = null,
    restrictSubmitted = null
  ) {
    const url = '/CrewTimecard/CloneCrewTimecard';
    const postData: any = {
      cloneFromTemplateID: cloneFromTemplateID,
      cloneToTemplateID: cloneToTemplateID,
      cloneFromPRPCKeyID: cloneFromPRPCKeyID,
      cloneToPRPCKeyID: cloneToPRPCKeyID,
      isCloneHours: isCloneHours,
      cloneType: cloneType,
    };
    if (dateFromString != null) postData.dateFromString = dateFromString;
    if (dateToString != null) postData.dateToString = dateToString;
    if (employeeList != null) postData.employeeList = employeeList;
    if (restrictSubmitted != null) postData.restrictSubmitted = restrictSubmitted;

    return this.http.post(url, postData).toPromise();
  }

  createLineFromClocks(crewTemplateID, employeeString, hQBCKeyID) {
    const url = '/CrewTimecard/CreateLineFromClocks';
    const postData: any = {
      createAsSubmitted: 0,
      crewTemplateID: crewTemplateID,
      employeeString: employeeString,
      hQBCKeyID: hQBCKeyID,
    };
    return this.http.post(url, postData).toPromise();
  }

  deleteTemplateData(crewTemplateDataID) {
    const url = '/CrewTimecard/DeleteTemplateData';
    return this.http
      .post(url, {
        crewTemplateDataID: crewTemplateDataID,
      })
      .toPromise();
  }

  groupTimeEntry(employeeString, clockTimeString, clockAction, pRCo) {
    const url = '/Timecard/GroupTimeEntry';
    return this.http
      .post(url, {
        employeeString: employeeString,
        clockTimeString: clockTimeString,
        clockAction: clockAction,
        pRCo: pRCo,
      })
      .toPromise();
  }

  insertTemplateData(crewLayoutDetailID, crewTemplateID, fieldValue, fieldIdentifier) {
    const url = '/CrewTimecard/InsertTemplateData';
    return this.http
      .post(url, {
        crewLayoutDetailID: crewLayoutDetailID,
        crewTemplateID: crewTemplateID,
        fieldValue: fieldValue,
        fieldIdentifier: fieldIdentifier,
      })
      .toPromise();
  }

  submitCrewTimecard(crewTemplateID, pRPCKeyID, submittedOnString, employees) {
    const url = '/CrewTimecard/SubmitCrewTimecard';
    return this.http
      .post(url, { crewTemplateID: crewTemplateID, pRPCKeyID: pRPCKeyID, submittedOnString: submittedOnString, employees: employees })
      .toPromise();
  }

  submitCrewTimecardEmployee(
    employee,
    pRCo,
    hQBCKeyID,
    questionRow,
    pRPCKeyID,
    crewTemplateID,
    actionString,
    submitSignatureStr,
    submitNoIssues,
    submitIssuesNotes,
    latitude,
    longitude,
    submittedOnString
  ) {
    const url = '/CrewTimecard/SubmitCrewTimecardEmployee';
    const postData: any = {
      employee: employee,
      pRCo: pRCo,
      hQBCKeyID: hQBCKeyID,
      pRPCKeyID: pRPCKeyID,
      crewTemplateID: crewTemplateID,
      actionString: actionString,
      submitSignatureStr: submitSignatureStr,
      submitNoIssues: submitNoIssues,
      submitIssuesNotes: submitIssuesNotes,
      latitude: latitude,
      longitude: longitude,
      submittedOnString: submittedOnString,
    };
    if (questionRow != null) postData.questionRow = questionRow;
    return this.http.post(url, postData).toPromise();
  }

  unsubmitCrewTimecard(unsubmitData: any) {
    const url = '/Crew/Timecard/UnsubmitCrewTimecard';
    return this.http.post(url, unsubmitData).toPromise();
  }

  getPRCoPRGroup() {
    return this.http.get('/Crew/Timecard/GetPRCoPRGroup').toPromise();
  }

  getEmployees(searchString: string, isTimecard?: boolean, pRCo?: number, pRGroup?: number) {
    const url =
      '/Timecard/GetEmployees?searchString=' + searchString + '&isTimecard=' + isTimecard + '&PRCo=' + pRCo + '&PRGroup=' + pRGroup;
    return this.http.get(url).toPromise();
  }

  addCrewMember(pRCRKeyID: number, employee: number) {
    const url = '/Crew/Timecard/CrewMemberAdd';
    return this.http
      .post(url, {
        PRCRKeyID: pRCRKeyID,
        employee: employee,
      })
      .toPromise();
  }

  addEditCrew(pRCRKeyID: number, crew: string, crewDescription: string, pRCo: number, pRGroup: number) {
    const url = '/Crew/Timecard/CrewAddEdit';
    return this.http
      .post(url, {
        PRCRKeyID: pRCRKeyID,
        crew: crew,
        crewDescription: crewDescription,
        PRCo: pRCo,
        PRGroup: pRGroup,
      })
      .toPromise();
  }

  deleteCrewMember(pRCWKeyID: number) {
    const url = '/Crew/Timecard/CrewMemberDelete';
    return this.http
      .post(url, {
        PRCWKeyID: pRCWKeyID,
      })
      .toPromise();
  }

  updateLayoutDetails(crewLayoutID: number, stickyColumnCount?: number, stickyJobApprovalCount?: number, description?: string) {
    const url = '/Crew/Timecard/UpdateLayoutDetails';
    return this.http
      .post(url, {
        crewLayoutID: crewLayoutID,
        stickyColumnCount: stickyColumnCount,
        stickyJobApprovalCount: stickyJobApprovalCount,
        description: description,
      })
      .toPromise();
  }

  updatelayout(layoutUpdateModel: any) {
    const url = '/Crew/Timecard/UpdateLayout';
    return this.http
      .post(url, {
        layoutUpdateModel: layoutUpdateModel,
      })
      .toPromise();
  }

  getLayoutColumns() {
    const url = '/Crew/Timecard/GetLayoutColumns';
    return this.http.get(url).toPromise();
  }

  deleteLayout(crewLayoutID: number) {
    const url = '/Crew/Timecard/DeleteLayout';
    return this.http
      .post(url, {
        crewLayoutID: crewLayoutID,
      })
      .toPromise();
  }

  getTemplates(userID: number, crewLayoutID: number) {
    const url = '/CrewTimecard/GetTemplates?userID=' + userID + '&crewLayoutID=' + crewLayoutID;
    return this.http.get(url).toPromise();
  }

  insertUpdateTemplateHeader(
    crewTemplateID: number,
    userKeyID: number,
    crewLayoutID: number,
    templateName: string,
    templateIsActive: boolean,
    templateCanBeEdited: boolean,
    templateIsShared: boolean
  ) {
    const url = '/Crew/Timecard/InsertUpdateTemplateHeader';
    return this.http
      .post(url, {
        crewTemplateID: crewTemplateID,
        userKeyID: userKeyID,
        crewLayoutID: crewLayoutID,
        templateName: templateName,
        templateIsActive: templateIsActive,
        templateCanBeEdited: templateCanBeEdited,
        templateIsShared: templateIsShared,
      })
      .toPromise();
  }

  deleteTemplateHeader(crewTemplateID: number) {
    const url = '/Crew/Timecard/DeleteTemplateHeader';
    return this.http
      .post(url, {
        crewTemplateID: crewTemplateID,
      })
      .toPromise();
  }

  getTemplateEmployees() {
    const url = '/Timecard/GetEmployees';
    return this.http.get(url).toPromise();
  }

  getCrewMemberMulti(crewIDs: any[]) {
    const url = '/CrewTimecard/GetCrewMemberMulti';
    return this.http.post(url, { PRCRKeyID: crewIDs }).toPromise();
  }
}